var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 765,
    height: 761,
    viewBox: "0 0 765 761",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.364 758.828C315.357 758.828 280.5 747.878 219.911 704.078C181.586 753.353 60.225 791.861 54.932 725.978C54.932 676.522 43.982 634.73 31.572 589.105C16.79 532.895 0 470.298 0 379.597C0 162.971 177.754 0 388.357 0C599.142 0 764.304 171.001 764.304 381.604C765.011 588.95 597.709 757.722 390.364 758.828ZM393.467 187.243C290.903 181.951 210.968 252.943 193.266 364.267C178.666 456.429 204.581 568.665 226.663 574.505C237.248 577.06 263.893 555.525 280.5 538.918C307.961 557.889 339.94 569.283 373.21 571.95C479.483 577.062 570.29 496.156 577.425 390C581.579 283.618 499.755 193.514 393.467 187.426V187.243Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxIcon);
export default __webpack_public_path__ + "static/media/maxIcon.3b034208317adc4277fe2989f1600c12.svg";
export { ForwardRef as ReactComponent };